import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Constants } from 'src/app/_consts/constants';
import { SharedService } from 'src/app/_shared/shared.service';
import { Fce } from 'src/app/SayTS/fce';
import { HttpPlus } from 'src/app/SayTS/http-plus';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SInputComponent } from 'src/app/SayTS/comps/s-input/s-input.component';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  imports: [FormsModule, TranslateModule, SInputComponent]
})
export class GroupComponent implements OnInit {

  public group
  public newGroup: boolean = false;
  public rights = Constants.GROUPS_RIGHTS;
  public modules = Constants.MODULES;
  dbEditByRight = environment.dbEditByRight
  tables = null

  constructor(protected activatedRoute: ActivatedRoute, protected http: HttpPlus, protected shared: SharedService,
    protected location: Location) { }

  ngOnInit(): void {
    this.tables = Constants.DB_EDITABLE_TABLES.map(t => { return { name: t, enabled: false } })

    if (this.activatedRoute.snapshot.params.id_group == 'new') {
      this.newGroup = true;
      this.group = { module: "" };
    } else {
      this.refresh()
    }
  }

  async refresh() {
    const response: any = await this.http.get(`group/${this.activatedRoute.snapshot.params.id_group}`)
    console.log(response)
    if (!response)
      return
    this.group = Fce.convertForClient(response.group);
    if (response.tables) {
      response.tables.forEach(t => {
        const table = this.tables.find(ta => ta.name == t.table_name)
        if (table)
          table.enabled = true
      })
    }
    return response
  }

  async saveGroup(paramsAdd: any = null) {
    const params = Fce.convertForServer({ ...this.group })
    if (paramsAdd) {
      Object.keys(paramsAdd).forEach(k => {
        params[k] = paramsAdd[k]
      })
    }
    params.tables = this.isBaseGroup() ? this.tables.filter(t => t.enabled).map(t => t.name) : []

    console.log(params)
    const response = await this.http.put(`group`, params)
    if (response) {
      this.shared.success()
      this.location.back();
    }
  }

  isBaseGroup() {
    return this.group?.module == Constants.MOD_BASE && this.shared.rightsAll?.[Constants.MOD_BASE]?.r_extra_5
  }

  getHelp(mod, r) {
    const key = `rights.help_${mod}_${r}`
    const t = this.shared.t(key)
    return t != key ? t : this.shared.t('not_used')
  }

  resetChecks() {
    this.rights.forEach(r => {
      this.group[r] = false
    })
  }

  checkAllTables(value) {
    this.tables.forEach(t => {
      t.enabled = !!value
    })
  }
}
